import React from 'react';
import { CHECKOUT_URL } from '../data/salesContent';
type CtaButtonSize = 'md' | 'lg';
type CtaButtonProps = {
  size?: CtaButtonSize;
  className?: string;
  label?: string;
};
export function CtaButton({
  size = 'lg',
  className = '',
  label = "💪 I'M READY — GET INSTANT ACCESS"
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg tracking-wide' : 'px-6 py-3.5 text-sm tracking-wide';
  return <a href={CHECKOUT_URL} className={`inline-flex w-full max-w-lg items-center justify-center rounded-full bg-gold font-bold text-ink-900 shadow-lift transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-gold-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-lilac-400 active:translate-y-0 ${sizeClasses} ${className}`} style={{
    fontSize: "14px",
    paddingLeft: "1px",
    paddingRight: "5px",
    alignItems: "center",
    justifyContent: "center"
  }} data-id="element-67" data-mp="qih5fd9u1vfk">
      {label}
    </a>;
}